// set at login only, so a refresh or a second tab never raises one
const PROMPT_PENDING = "twoFactor:passkeyPromptPending";

// two facts, not one: unable to enrol and nothing to sign with want opposite answers
const PASSKEY_WORKED_HERE = "twoFactor:passkeyOnDevice";
const CANNOT_ENROL_HERE = "twoFactor:passkeyCannotEnrol";

// a device gets fixed, so one bad day must not silence the ask forever
const RETRY_CANNOT_ENROL_MS = 30 * 86400000;

// storage can be unwritable in a private window, and the common case is one tab anyway
let pending = false;

export const markPasskeyPrompt = () => {
    pending = true;

    try {
        sessionStorage.setItem(PROMPT_PENDING, "1");
    } catch (ignore) {}
};

// one shot: reading it clears it, so a later navigation cannot raise a second prompt
export const consumePasskeyPrompt = () => {
    let stored = false;

    try {
        stored = sessionStorage.getItem(PROMPT_PENDING) === "1";
        sessionStorage.removeItem(PROMPT_PENDING);
    } catch (ignore) {}

    const owed = pending || stored;

    pending = false;

    return owed;
};

// a peek, not a consume: lets the install offer wait for the passkey prompt to have its turn
export const isPasskeyPromptPending = () => {
    if (pending) return true;

    try {
        return sessionStorage.getItem(PROMPT_PENDING) === "1";
    } catch (error) {
        return false;
    }
};

/** Webauthn will not list credentials, so having used one is the only proof of one. */
export const passkeyWorkedHere = () => {
    try {
        return localStorage.getItem(PASSKEY_WORKED_HERE) === "yes";
    } catch (error) {
        return false;
    }
};

export const markPasskeyWorkedHere = () => {
    try {
        localStorage.setItem(PASSKEY_WORKED_HERE, "yes");
        localStorage.removeItem(CANNOT_ENROL_HERE);
    } catch (ignore) {}
};

/** Forgetting on every failure is what keeps these flags from ever needing a manual clear. */
export const forgetPasskeyWorkedHere = () => {
    try {
        localStorage.removeItem(PASSKEY_WORKED_HERE);
    } catch (ignore) {}
};

/** Written only on hard evidence: no authenticator, or one that cannot meet the options. */
export const markCannotEnrolHere = () => {
    try {
        localStorage.setItem(CANNOT_ENROL_HERE, String(Date.now()));
    } catch (ignore) {}
};

export const cannotEnrolHere = () => {
    try {
        const at = Number(localStorage.getItem(CANNOT_ENROL_HERE)) || 0;

        return !!at && Date.now() - at < RETRY_CANNOT_ENROL_MS;
    } catch (error) {
        return false;
    }
};
